/**
 * Scroll an element into view but with an offset.
 * @param {String|Object} selector Can be a selector or alredy an element.
 * @param {number} offset Offset
 */

const scrollIntoViewWithOffset = (selector, offset) => {
  let element = selector;
  if (typeof selector === "string") {
    element = document.querySelector(selector);
  }

  window.scrollTo({
    // Only god knows why, but scrolling smoothly will destroy the scroll target, resulting in a scrollTo End of screen height
    behavior:
      typeof window !== "undefined" && window.innerWidth < 768
        ? "instant"
        : "smooth",
    top:
      element.getBoundingClientRect().top -
      document.body.getBoundingClientRect().top -
      offset,
  });
};

export default scrollIntoViewWithOffset;
